var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPdfFaqIcon = function SvgPdfFaqIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.552
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#1F1F1F",
    strokeWidth: 1.105
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.552 18.384V3.903c0-1.91-1.546-3.455-3.454-3.455H4.007C2.099.448.552 1.994.552 3.903v16.09c0 1.908 1.547 3.455 3.455 3.455h14.482l5.063-5.064z",
    transform: "translate(-619 -562) translate(619 562) translate(0 .104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 23.23v-5.196c0-.2.16-.36.358-.36h5.198",
    transform: "translate(-619 -562) translate(619 562) translate(0 .104)"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#1F1F1F",
    fontFamily: "Montserrat-SemiBold, Montserrat",
    fontSize: 7.168,
    fontWeight: 500,
    letterSpacing: -0.01,
    transform: "translate(-619 -562) translate(619 562)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.242,
    y: 12.411
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.365,
    y: 12.411,
    letterSpacing: 0.06
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    x: 15.346,
    y: 12.411
  }, "F"))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdfFaqIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf_faq_icon.1340987f.svg";
export { ForwardRef as ReactComponent };